import { render, staticRenderFns } from "./SafetyCreate.vue?vue&type=template&id=5ff3528a&scoped=true&"
import script from "./SafetyCreate.vue?vue&type=script&lang=js&"
export * from "./SafetyCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff3528a",
  null
  
)

export default component.exports